import { requestApi } from '../util/network'
// 获取签名信息
export const getWechatShare =
(params) =>
  requestApi(
    '/index/getWechatShare',
    'POST',
    {
        url:params.url,
    }
  )
// 获取分享内容接口
export const getWechatShareContent =
    (params) =>
      requestApi(
        '/index/getWechatShareContent',
        'POST',
        {
          'type': params.type,
          'goods_id':params.goods_id,
          'store_id':params.store_id
        },
        'member'
      )
